<ChapterNav params="{params}" segment="abgeschlossen" />

{#if ch}
  <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
    <div
      class="media px-4 py-4 {!hasReachedErrorTreshhold ? 'is-success-light has-background-success-light' : 'is-warning-light has-background-warning-light'}"
    >
      <span class="media-left">
        <Icon
          icon="{!hasReachedErrorTreshhold ? 'check' : 'exclamation'}"
          type="{!hasReachedErrorTreshhold ? 'success' : 'warning'}"
          size="large"
          iconSize="fa-3x"
        />
      </span>
      {#if demoSvc.isDemoInstance() && !hasReachedErrorTreshhold}
        <div class="media-content ml-5">
          Du hast alle Fragen beantwortet und damit die Demo erfolgreich
          abgeschlossen!
          <br />
          Gerne kannst du dich weiter umsehen, die weiteren Kapitel sind jedoch
          nur in der echten Version verfügbar.
        </div>
      {:else if !hasReachedErrorTreshhold}
        <div class="media-content ml-5">
          Du hast alle Fragen beantwortet!<br />
          {#if userApproved && (!nextChapter?.title || allExamsFinished)}
            <br />
            <strong>Damit hast du die theoretische Platzreife erfolgreich
              abgelegt.
            </strong>
            <br />
            <br />
            Wende dich als nächstes an deinen Golfclub um mit der Platzreife
            fortzufahren. Die Prüfungsinformationen wurden bereits
            weitergeleitet.
          {:else if userApproved}
            Beginne jetzt mit der nächsten Lektion.
          {:else}
            Die nächste Lektion kannst du beginnen, sobald du vom Golfclub
            freigeschalten wurdest. Gerne kannst du uns dazu auch anrufen, um
            den Vorgang zu beschleunigen.
          {/if}
        </div>

        {#if userApproved && nextChapter?.title && !allExamsFinished}
          <button
            class="button mt-3 mb-3 {!hasReachedErrorTreshhold ? 'is-success' : 'is-warning'}"
            on:click="{() => finishedContinue()}"
          >{@html nextChapter?.title}</button>
        {/if}
      {:else}
        <div class="media-content ml-5">
          Leider hast du diese Prüfung nicht bestanden.
          <br />Versuche dein bitte Glück erneut.
        </div>
        <button
          class="button mt-3 mb-3 {!hasReachedErrorTreshhold ? 'is-success' : 'is-warning'}"
          on:click="{() => erroredContinue()}"
        >Prüfung wiederholen</button>
      {/if}
    </div>

    {#if wrongQuestions?.length}
      <div class="is-warning-light px-4 py-4 mt-6 has-background-warning-light">
        <h3 class="is-size-5 mb-4">Falsch beantwortete Fragen:</h3>
        <ul>
          {#each wrongQuestions as wq}
            <li>{wq.frage}</li>
          {/each}
        </ul>
      </div>
    {/if}
  </div>
{/if}

<script>
import { onMount } from "svelte";
import * as animateScroll from "svelte-scrollto";
import {
  chapters,
  currentChapter,
  questions,
  userProgress,
  userIsApproved,
  examProgress,
} from "./stores";
import Icon from "./Icon.svelte";
import ChapterNav from "./ChapterNav.svelte";
import { push } from "svelte-spa-router";
import { demoSvc, examSvc, progressSvc } from "./services";
import { allowedWrongAnswersPerChapter } from "./constants";

export let params = {};

let allExamsFinished,
  ch,
  chs,
  nextChapter,
  up,
  userApproved,
  qs,
  wrongQuestions;

const topScroll = () =>
  animateScroll.scrollTo({
    element: ".nav-chapters",
    offset: -100,
    duration: 250,
  });

const finishedContinue = () => {
  topScroll();
  push("/platzreife/" + nextChapter.slug);
};

const erroredContinue = () => {
  topScroll();
  examSvc.resetExam();
  push("/platzreife/" + ch.slug + "/pruefung");
};

const setWrongQuestions = () => {
  if (!up || !qs || !ch) {
    return;
  }
  wrongQuestions = qs.filter((q) => q.fixated && q.status == false);
};

$: hasReachedErrorTreshhold =
  wrongQuestions && wrongQuestions?.length > allowedWrongAnswersPerChapter;

onMount(() => {
  const setValues = () => {
    if (!ch || !chs) {
      return;
    }
    const slugIdx = chs.map((d) => d.slug).indexOf(ch.slug);
    nextChapter = chs[slugIdx + 1];
  };

  userProgress.subscribe((data) => {
    up = data;
    setWrongQuestions();
  });

  currentChapter.subscribe((value) => {
    if (value == undefined) {
      return;
    }
    ch = value;
    setValues();
  });

  chapters.subscribe((data) => {
    if (!data) {
      return;
    }
    chs = data;
    setValues();
  });

  questions.subscribe((data) => {
    qs = data;
    setWrongQuestions();
  });

  userIsApproved.subscribe((bool) => {
    userApproved = bool;
  });

  examProgress.subscribe((_) => {
    allExamsFinished = progressSvc.allExamsFinished();
  });
});
</script>

<style type="text/scss">
</style>
